import { ENUM__debug_feature_client } from '@/_debug/ENUM__debug_feature_client';
import { Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface Props {
  children: React.ReactNode;
  tooltip_title: string | React.ReactNode;
  delay_duration?: number;
  skip_delay_duration?: number;
  className?: string;
  side?: 'left' | 'right' | 'top' | 'bottom';
  open?: boolean;
}

export const UI_PRIMITIVE__tooltip: React.FC<Props> = ({
  children,
  tooltip_title,
  delay_duration,
  skip_delay_duration,
  className,
  side = 'top',
  open = false,
}) => {
  if (!tooltip_title) return children;
  if (!ENUM__debug_feature_client.ENABLE_TOOLTIPS) return children;

  return (
    <TooltipProvider delayDuration={delay_duration} skipDelayDuration={skip_delay_duration}>
      <Tooltip {...{ open }}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipPortal>
          <TooltipContent
            className={`  max-w-[20rem]
                          break-words
                          overflow-hidden
                          h-auto
                          text-left ${className}`}
            {...{ side }}
          >
            {tooltip_title}
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
    </TooltipProvider>
  );
};
